import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPI } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const trackShipmentById = createAsyncThunk(
  'tracking/trackShipment',
  async (trackingId, { rejectWithValue }) => {
    try {
      const response = await callAPI(
        `${apiUrls.shipmentSearch}`,
        {orderId: trackingId},
        'GET',
        {}
      );

      if (response?.data?.success) {
        return response.data.data;
      }
      return rejectWithValue(response?.data?.message || 'Shipment not found');
      
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch shipment');
    }
  }
);

const initialState = {
  trackingId: "",
  shipment: null,
  loading: false,
  error: null,
  searched: false
};

const trackingSlice = createSlice({
  name: 'tracking',
  initialState,
  reducers: {
    setTrackingId: (state, action) => {
      state.trackingId = action.payload;
      state.error = null;
    },
    clearTracking: (state) => {
      state.trackingId = "";
      state.shipment = null;
      state.error = null;
      state.searched = false;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(trackShipmentById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.searched = false;
      })
      .addCase(trackShipmentById.fulfilled, (state, action) => {
        state.loading = false;
        state.shipment = action.payload; 
        state.searched = true;
        state.error = null;
      })
      .addCase(trackShipmentById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to track shipment';
        state.shipment = null;
        state.searched = true;
      });
  }
});

export const { setTrackingId, clearTracking, clearError } = trackingSlice.actions;
export default trackingSlice.reducer;